// Functionality/BasePaper.tsx
import React from "react";
import { Paper, useTheme } from "@mui/material";

interface BasePaperProps {
  children: React.ReactNode;
  direction?: "row" | "column";
  backgroundColor?: string;
  color?: string;
}

const BasePaper: React.FC<BasePaperProps> = ({ children, direction = "row", backgroundColor, color }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={1}
      sx={{
        p: 1,
        display: "flex",
        flexDirection: direction,
        alignItems: direction === "row" ? "center" : "flex-start",
        gap: 1,
        backgroundColor: backgroundColor ?? theme.custom.nodes.background.main.dark,
        color: color ?? theme.custom.nodes.text.input.dark,
        borderRadius: "6px",
        width: "100%",

        // 🔥 Required so that children (like MUI selects) can receive pointer events
        pointerEvents: "all",
      }}
    >
      {children}
    </Paper>
  );
};

export default BasePaper;
